import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, ChevronRight } from 'lucide-react';
import { blogPosts } from '../data/blogPosts';

export function BlogList() {
  return (
    <div className="max-w-4xl mx-auto py-8 px-4">
      <div className="mb-12 text-center">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">Unit Converter Blog</h1>
        <p className="text-lg text-gray-600">Learn about measurement systems, conversions, and practical applications.</p>
      </div>
      
      <div className="space-y-8">
        {blogPosts.map(post => (
          <article 
            key={post.id} 
            className="bg-white rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-200"
          >
            <Link 
              to={`/blog/${post.id}`} 
              className="block p-6"
            >
              <div className="flex items-center text-sm text-gray-500 mb-3">
                <Calendar className="w-4 h-4 mr-2" />
                {new Date(post.date).toLocaleDateString()}
              </div>
              
              <h2 className="text-2xl font-bold text-gray-900 mb-3 hover:text-blue-600 transition-colors">
                {post.title}
              </h2>
              
              <p className="text-gray-600 mb-4">
                {post.description}
              </p>
              
              <div className="flex items-center text-blue-600 font-medium">
                Read article 
                <ChevronRight className="w-4 h-4 ml-1" />
              </div>
            </Link>
          </article>
        ))}
      </div>
    </div>
  );
} 